module.exports = {
	"id": "NG",
	"name": "Nigeria",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": 0.001637,
			"5": null,
			"6": 0.001637,
			"7": 0.001637,
			"8": null,
			"9": 0.003274,
			"10": null,
			"11": 0.01637,
			"12": 0.001637,
			"13": null,
			"14": null,
			"15": 0.027829,
			"16": 0.003274,
			"17": null,
			"18": null,
			"19": 0.006548,
			"20": 0.006548,
			"21": 0.014733,
			"22": 0.014733,
			"23": 0.039288,
			"24": 0.003274,
			"25": 0.006548,
			"26": 0.024555,
			"27": 0.004911,
			"28": 0.018007,
			"29": 0.011459,
			"30": 0.009822,
			"31": 0.054021,
			"32": 0.006548,
			"33": 0.024555,
			"34": 0.004911,
			"35": 0.003274,
			"36": 0.008185,
			"37": 0.004911,
			"38": 0.006548,
			"39": 0.008185,
			"40": 0.011459,
			"41": 0.008185,
			"42": 0.008185,
			"43": 0.044199,
			"44": 0.009822,
			"45": 0.027829,
			"46": 0.01637,
			"47": 0.034377,
			"48": 0.026192,
			"49": 0.173522,
			"50": 0.034377,
			"51": 0.219358,
			"52": 0.152241,
			"53": 4.180898,
			"54": 1.072235,
			"55": 0.040925,
			"56": 0.011459,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": 0.045836,
			"4": 0.018007,
			"5": 0.003274,
			"6": 0.004911,
			"7": 0.027829,
			"8": 0.004911,
			"9": 0.003274,
			"10": 0.019644,
			"11": 0.022918,
			"12": 0.018007,
			"13": 0.045836,
			"14": 0.008185,
			"15": 0.067117,
			"16": 0.013096,
			"17": 0.006548,
			"18": 0.013096,
			"19": 0.029466,
			"20": 0.008185,
			"21": 0.008185,
			"22": 0.011459,
			"23": 0.004911,
			"24": 0.004911,
			"25": 0.008185,
			"26": 0.008185,
			"27": 0.009822,
			"28": 0.004911,
			"29": 0.031103,
			"30": 0.024555,
			"31": 0.019644,
			"32": 0.011459,
			"33": 0.019644,
			"34": 0.019644,
			"35": 0.031103,
			"36": 0.022918,
			"37": 0.026192,
			"38": 0.045836,
			"39": 0.036014,
			"40": 0.044199,
			"41": 0.055658,
			"42": 0.045836,
			"43": 0.276653,
			"44": 0.170248,
			"45": 0.099857,
			"46": 0.093309,
			"47": 0.571313,
			"48": 0.492737,
			"49": 2.319629,
			"50": 0.387969,
			"51": 0.008185,
			"52": null,
			"3.5": 0.001637,
			"3.6": 0.022918
		},
		"opera": {
			"9": null,
			"11": 0.001637,
			"12": 0.009822,
			"15": 0.004911,
			"16": null,
			"17": null,
			"18": 0.004911,
			"19": 0.006548,
			"20": 0.003274,
			"21": null,
			"22": 0.003274,
			"23": null,
			"24": null,
			"25": null,
			"26": 0.001637,
			"27": 0.001637,
			"28": 0.003274,
			"29": 0.009822,
			"30": 0.014733,
			"31": 0.001637,
			"32": 0.009822,
			"33": 0.014733,
			"34": 0.018007,
			"35": 0.024555,
			"36": 0.01637,
			"37": 0.240639,
			"38": 0.008185,
			"39": 0.024555,
			"40": 0.297934,
			"41": 0.039288,
			"42": 0.001637,
			"43": null,
			"9.5-9.6": 0.004911,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": 0.008185,
			"11.6": 0.003274,
			"12.1": 0.034377
		},
		"safari": {
			"0": null,
			"4": 0.001637,
			"5": 0.001637,
			"6": null,
			"7": 0.006548,
			"8": 0.024555,
			"9": 0.026192,
			"10": 0.099857,
			"3.1": null,
			"3.2": null,
			"5.1": 0.006548,
			"6.1": 0.004911,
			"7.1": 0.054021,
			"9.1": 0.067117
		},
		"ios_saf": {
			"8": 0,
			"10": 0.783218277269,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.0211068262906,
			"8.1-8.4": 0.0389939672148,
			"9.0-9.2": 0.0186026265612,
			"9.3": 0.283809302664
		},
		"android": {
			"3": 0,
			"4": 0.0396324082687,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00495405103359,
			"4.1": 0.142959758398,
			"4.2-4.3": 0.357399395995,
			"4.4": 0.819541585271,
			"4.4.3-4.4.4": 0.826618801034
		},
		"ie": {
			"6": 0.00338862582057,
			"7": 0.00169431291028,
			"8": 0.133850719912,
			"9": 0.047440761488,
			"10": 0.0864099584245,
			"11": 0.494739369803,
			"5.5": null
		},
		"op_mob": {
			"0": 4.09481567484,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.113744879857
		},
		"edge": {
			"12": 0.072028,
			"13": 0.091672,
			"14": 0.101494
		},
		"ie_mob": {
			"10": 0.225918788732,
			"11": 0.919812211268
		},
		"bb": {
			"7": 0.6481325,
			"10": null
		},
		"samsung": {
			"0": 0.744307
		},
		"and_uc": {
			"0": 8.965136
		},
		"op_mini": {
			"0": 55.1687394453
		},
		"and_chr": {
			"0": 8.854231
		},
		"and_ff": {
			"0": 0.091993
		}
	},
	"total": 97.0124582484
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/NG.json
 ** module id = 608
 ** module chunks = 0
 **/